import React from 'react';
import { Row, Col, Form, Input, message } from 'antd';
import { QuestionMark } from '@partsbadger/ui-library';
import { ZOHO_ZIP_CODE_MAX_LENGTH } from '@partsbadger/utils';
import { validatePhoneNumber } from '@/utils/utils';

interface IQuoteContactFormProps {
    firstName: string;
    lastName: string;
    isHobbyist: boolean;
    hasAccount: boolean;
    shouldHideNames?: boolean
}

const QuoteContactForm: React.FC<IQuoteContactFormProps> = ({ firstName, lastName, isHobbyist, hasAccount, shouldHideNames = true }) => {
    const form = Form.useFormInstance();
    return (
        <Row>
            {!shouldHideNames && (
                <Form.Item
                    name="first_name"
                    label="First Name"
                    rules={[{ required: true, message: 'Please input the first name' }]}
                    hasFeedback
                >
                    <Input
                        size="small"
                        style={{ width: '90%' }}
                    />
                </Form.Item>
            )}

            {!shouldHideNames && (
                <Col xl={12} span={24}>
                    <Form.Item
                        name="last_name"
                        label="Last Name"
                        rules={[{ required: true, message: 'Please input the last name' }]}
                        hasFeedback={true}
                    >
                        <Input size="small" style={{ width: '90%' }} />
                    </Form.Item>
                </Col>
            )}

            {!isHobbyist && !hasAccount && (
                <Col md={12} span={24}>
                    <Form.Item
                        name="company"
                        label="Company"
                        rules={[{ required: true, message: 'Please input a Company' }]}
                        hasFeedback={true}
                    >
                        <Input size="small" style={{ width: '90%' }} />
                    </Form.Item>
                </Col>
            )}

            {
                <Col md={12} span={24}>
                    <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[
                            {
                                validator: (_, value) => validatePhoneNumber(value, false),
                            },
                        ]}
                        hasFeedback={true}
                    >
                        <Input
                            style={{ width: '90%' }}
                            size="small"
                            placeholder="Enter phone number"
                            inputMode="tel"
                            maxLength={20}
                        />
                    </Form.Item>
                </Col>
            }

            <Col md={12} span={24}>
                <Form.Item
                    name="shipping_zip_code"
                    label={
                        <>
                            Zip/Postal Code <QuestionMark>Zip code required for estimating sales tax</QuestionMark>
                        </>
                    }
                    rules={[
                        { required: true, message: 'Please insert a Zip/Postal Code' },
                        { min: 5, message: 'Zip/Postal Code must be at least 5 characters' },
                        // Zoho's Shipping_Code field rejects values longer than this.
                        {
                            max: ZOHO_ZIP_CODE_MAX_LENGTH,
                            message: `Zip/Postal Code must be at most ${ZOHO_ZIP_CODE_MAX_LENGTH} characters`,
                        },
                    ]}
                    hasFeedback={true}
                >
                    <Input style={{ width: '90%' }} size="small" maxLength={ZOHO_ZIP_CODE_MAX_LENGTH} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default QuoteContactForm;
